import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CustomHttp, ConfigServerService } from '../../../../core';
import { ClienteJaCadastrado } from './cliente-ja-cadastrado';

@Injectable({
    providedIn: 'root'
})
export class ClienteValidacoesHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/cliente`;
    }

    /** Obtem o cliente já cadastrado através do seu CNPJ/CPF quando houver um */
    getClienteJaCadastrado(idPessoa: number, cnpjCpf: string, idRepresentante: number, editMode: boolean): Observable<ClienteJaCadastrado> {
        // Params
        let params = new HttpParams();
        // ID da Pessoa
        if (idPessoa) {
            params = params.append('idPessoa', idPessoa.toString());
        }
        // CNPJ/CPF
        if (cnpjCpf) {
            params = params.append('cnpjCpf', cnpjCpf);
        }
        // Representante
        if (idRepresentante) {
            params = params.append('idRepresentante', idRepresentante.toString());
        }
        // Edit Mode (Se está editando ou não o cliente)
        if (editMode) {
            params = params.append('editMode', editMode.toString());
        }


        return this.customHttp.get<ClienteJaCadastrado>(`${this.pathApi}/0/validacoes/jacadastrado`, {params});
    }
}
